/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING,
  isLoading: value,
});

export const setSearchInput = (data) => {
  return {
    type: ActionTypes.SET_SELECTED_INPUT,
    payload: data,
  };
};

export const setTerminatedLabelerReport = (data) => ({
  type: ActionTypes.SET_TERMINATED_LABELER_REPORT,
  payload: data,
});

export const refreshTerminatedLabelerDisplay = () => ({
  type: ActionTypes.REFRESH_TERMINATED_LABELER_DISPALY,
  payload: {},
});
export const refreshTerminatedLabeler = () => ({
  type: ActionTypes.REFRESH_TERMINATED_LABELER,
  payload: {},
});

// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  // dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

//API to get Reabte Program List
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data.data;
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
};

// API to get terminated labeler Reports data
export const getTerminatedLabelerReports = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_TERMINATED_LABELER, values)
    .then((response) => {
      dispatch(setLoading(false));
      if (response?.data?.terminatedLabelerReportVO.length === 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(
          setTerminatedLabelerReport(response?.data?.terminatedLabelerReportVO)
        );
      }
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setTerminatedLabelerReport([]));
    });
};
